
import { PromoCode, Product as PromoProduct } from '@/types/promoCode';

/**
 * Helper function to safely parse JSON
 */
export const safelyParseJson = (jsonString: string | null): any => {
  if (!jsonString) return null;
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error('Error parsing JSON:', e);
    return null;
  }
};

/**
 * Returns date with time set to midnight (00:00:00)
 */
export const getDateWithoutTime = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

/**
 * Parses selected products from JSON or object
 */
export const parseSelectedProducts = (data: any): PromoProduct[] => {
  if (!data) return [];
  
  try {
    const productsData = typeof data === 'string' 
      ? safelyParseJson(data) 
      : data;
    
    if (!Array.isArray(productsData)) return [];
    
    return productsData.map((p: any) => ({
      id: p.id || 0,
      name: p.name || '',
      price: p.price || 0,
      description: p.description || '',
      image: p.image || '',
      category: p.category || ''
    }));
  } catch (error) {
    console.error('Error parsing selected products:', error);
    return [];
  }
};
